import { render } from "./Contact.vue?vue&type=template&id=58d2ad5b&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=58d2ad5b&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/aldasforras_vue/aldasforras_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58d2ad5b"]])

export default __exports__